// telecallingTypes.js
export const REQUEST_TELECALLING_DETAILS_ = "REQUEST_TELECALLING_DETAILS_";
export const RECEIVED_TELECALLING_DETAILS_ = "RECEIVED_TELECALLING_DETAILS_";
export const RECEIVED_ERROR = "RECEIVED_ERROR";